module.exports = __webpack_public_path__ + "static/p-5-a66b82e363a524757c084bf70e879d8a.jpg";